/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as _ from 'underscore';

class CreateFeedHeader extends React.Component {
	render(){

		let section = null;

		if (this.props.sectionLink !== '') {
			section = (
				<Link to={this.props.sectionLink} params={this.props.sectionParams} className="breadcrumb">
					{this.props.section}
				</Link>
			);
		} else {
			section = this.props.section;
		}

		return(
			<div className="editor-title-bar">
				<span className="editor-title label-left">
					{section}
				</span>
				<i className="fa fa-angle-right editor-title-icon"></i>
				<span className="editor-title label-right">{this.props.action}</span>
				{this.props.tabs}
			</div>
		);
	}
};

CreateFeedHeader.displayName = "CreateFeedHeader";

CreateFeedHeader.propTypes = {
	section: PropTypes.string,
	sectionLink: PropTypes.string,
	sectionParams: PropTypes.object,
	action: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	]),
	tabs: PropTypes.element
};

CreateFeedHeader.defaultProps = {
	section: 'Your Feeds',
	sectionLink: '',
	sectionParams: {},
	action: 'New Feed',
	tabs: null
};

export default CreateFeedHeader;
